module.exports = __webpack_public_path__ + "img/skyfirst-logo.a411f16c.png";